import React, { useState, useEffect } from "react";

import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import {
    FormControl,
    Select,
    MenuItem,
    Chip,
} from "@mui/material";
import "./GlobalItemList.css";
import { useTheme } from "@mui/material/styles";
import { hexToRgba } from "../../Utils";

export default function UserDropDown(props) {
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(props.value || '');
    const theme = useTheme();

    // Ensure items is always an array
    const items = Array.isArray(props.items) ? props.items : [];

    // Effect to update selectedItem when props.value changes
    useEffect(() => {
        setSelectedItem(props.value || '');
    }, [props.value]);

    const handleDelete = () => {
        setSelectedItem("");
        props.setSelectedUserName("");
    }
    
    return (
        <FormControl
            variant="outlined"
            sx={{ m: 1, width: props.width ? props.width : {md:'20vw',sm:'40vw', xs:'58vw'}, backgroundColor: "#FFFFFF", color: '#000',}}
        >
            <Select
                id={props.id}
                defaultValue={true}
                disabled={props.disabled || false}
                onChange={(event) => {
                    setSelectedItem(event.target.value);
                    props.setSelectedUserName(event.target.value);                 
                }}
                sx={{
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "0px",
                    borderColor: "transparent",
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${theme.palette.primary.main}`,
                        borderRadius: '10px'
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "& .MuiSelect-icon": { color: "#AEAFB4" },
                    "& .MuiChip-root": {
                        color: "white",
                        backgroundColor: "#FFFFFF",
                    },
                    "&:hover": {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: `${theme.palette.primary.main}`,
                        },
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: `${theme.palette.primary.main}`,
                    },
                    "&.Mui-focused .MuiChip-root": {
                        backgroundColor: "#FFFFFF",
                    },
                }}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                placeholder={`Select a ${props.placeholder}`}
                renderValue={() =>
                    selectedItem === '' ? (
                        <div style={{color: "black"}}>Select a {props.placeholder}</div>
                    ) : (
                        <Chip
                            key={selectedItem}
                            label={selectedItem}
                            deleteIcon={
                                <CancelRoundedIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                />
                            }
                            style={{ margin: 2, backgroundColor: `${hexToRgba(theme.palette.primary.main, 0.20)} !important`, color: 'black' }}
                            onDelete={handleDelete}
                        />
                    )
                }
            >
                {items.length > 0 ? (
                    items.map((item) => (
                        <MenuItem key={item.id || item.value || item.name} value={item.name}>
                            {item.name}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem key={`no-${props.id || 'items'}`} value="" disabled>
                        No {props.placeholder || 'items'} found
                    </MenuItem>
                )}
            </Select>
        </FormControl>
    );
}
